import {
  GenderTypeEnum,
  GovtIdProofEnum,
  MaritalStatusEnum,
} from "../../../../shared/utils/enum";
import { formatDateForInput } from "../../../../shared/utils/formatDate";
import { Grid, MenuItem, TextField } from "../../../../shared/utils/muiImports";
import { PersonalDetailsProps } from "../User.type";

const PersonalDetailsForm: React.FC<PersonalDetailsProps> = ({
  onChange,
  errors,
  personalDetails,
}) => {
  return (
    <>
      <Grid item xs={12} md={3}>
        <TextField
          label={<span>First Name *</span>}
          name="personalDetails.firstName"
          fullWidth
          margin="none"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={personalDetails?.firstName || ""}
          onChange={onChange}
          error={Boolean(errors.firstName)}
          helperText={errors.firstName}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label="Middle Name"
          name="personalDetails.middleName"
          fullWidth
          margin="none"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={personalDetails?.middleName}
          onChange={onChange}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label={<span>Last Name *</span>}
          name="personalDetails.lastName"
          fullWidth
          margin="none"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={personalDetails?.lastName}
          onChange={onChange}
          error={Boolean(errors.lastName)}
          helperText={errors?.lastName}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label={<span>Date of Birth *</span>}
          name="personalDetails.dateOfBirth"
          fullWidth
          margin="none"
          size="small"
          type="date"
          InputLabelProps={{ shrink: true }}
          value={formatDateForInput(personalDetails?.dateOfBirth)}
          onChange={onChange}
          error={Boolean(errors.dateOfBirth)}
          helperText={errors?.dateOfBirth}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label={<span>Gender *</span>}
          name="personalDetails.gender"
          fullWidth
          margin="none"
          size="small"
          select
          InputLabelProps={{ shrink: true }}
          value={personalDetails?.gender}
          onChange={onChange}
          error={Boolean(errors.gender)}
          helperText={errors?.gender}
        >
          {Object.keys(GenderTypeEnum).map((key) => (
            <MenuItem
              key={key}
              value={GenderTypeEnum[key as keyof typeof GenderTypeEnum]}
            >
              {GenderTypeEnum[key as keyof typeof GenderTypeEnum]}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label={<span>Marital Status *</span>}
          name="personalDetails.maritalStatus"
          fullWidth
          margin="none"
          size="small"
          select
          InputLabelProps={{ shrink: true }}
          value={personalDetails?.maritalStatus}
          onChange={onChange}
          error={Boolean(errors.maritalStatus)}
          helperText={errors?.maritalStatus}
        >
          {Object.keys(MaritalStatusEnum).map((key) => (
            <MenuItem
              key={key}
              value={MaritalStatusEnum[key as keyof typeof MaritalStatusEnum]}
            >
              {MaritalStatusEnum[key as keyof typeof MaritalStatusEnum]}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label={<span>Govt. ID Proof *</span>}
          name="personalDetails.govtIdProof"
          fullWidth
          margin="none"
          size="small"
          select
          InputLabelProps={{ shrink: true }}
          value={personalDetails?.govtIdProof}
          onChange={onChange}
          error={Boolean(errors.govtIdProof)}
          helperText={errors?.govtIdProof}
        >
          {Object.keys(GovtIdProofEnum).map((key) => (
            <MenuItem
              key={key}
              value={GovtIdProofEnum[key as keyof typeof GovtIdProofEnum]}
            >
              {GovtIdProofEnum[key as keyof typeof GovtIdProofEnum]}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      <Grid item xs={12} md={3}>
        <TextField
          label={<span>ID Proof Number *</span>}
          name="personalDetails.idProofNumber"
          fullWidth
          margin="none"
          size="small"
          InputLabelProps={{ shrink: true }}
          value={personalDetails?.idProofNumber}
          onChange={onChange}
          error={Boolean(errors.idProofNumber)}
          helperText={errors?.idProofNumber}
        />
      </Grid>
    </>
  );
};

export default PersonalDetailsForm;
